export default __webpack_public_path__ + "static/media/Aetonix_logo.fa71e8e3.png";